import { useSelector } from 'react-redux';

import {
  hasInitializationError,
  getInitializationErrorName,
  getInitializationErrorMessage,
} from '../selectors';

export function useInitializeError() {
  const hasError = useSelector(hasInitializationError);
  const errorName = useSelector(getInitializationErrorName);
  const errorMessage = useSelector(getInitializationErrorMessage);

  return {
    hasInitializationError: hasError,
    initializationErrorName: errorName,
    initializationErrorMessage: errorMessage,
  };
}
